import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {UserService} from '../../auth-client/services/user.service';
import {AuthService} from '../../auth-client/services/auth.service';
import {LocalStorageService} from 'src/app/modules/local-storage/local-storage.module';
import {sha256} from 'js-sha256';
import {environment} from '../../../../environments/environment';

@Injectable()
export class AuthGuard  {

  constructor(
    private router: Router,
    private settingsService: AuthService,
    private userService: UserService,
    private localStorageService: LocalStorageService,
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    console.log(this.localStorageService.get('access-token'))
    console.log(` in guard ${this.settingsService.isAuthenticated()}`)
    if (this.settingsService.isAuthenticated()) {
      return true;
    } else {
      if (this.localStorageService.keys().indexOf('state') === -1) {
        this.localStorageService.set('state', 'SDJ2902SJC');
      }
      if (this.localStorageService.keys().indexOf('code_challenge') === -1) {
        this.localStorageService.set('code_challenge', 'ASR$%&&D#@A');
      }
      const base65Sha256Hash = btoa(sha256.create().update(this.localStorageService.get('code_challenge')).hex());
      window.location.href = `${environment.auth_api}auth/dialog?response_type=code&client_id=${environment.client_id}` +
        `&redirect_uri=${environment.redirectUri}&scope=Scope1&state=${this.localStorageService.get('state')}` +
        `&code_challenge=${base65Sha256Hash}&code_challenge_method=S256`;

      return false;
    }

  }
}
